import { render, staticRenderFns } from "./CreateProductDialog.vue?vue&type=template&id=07d3b83a&scoped=true&"
import script from "./CreateProductDialog.vue?vue&type=script&lang=js&"
export * from "./CreateProductDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateProductDialog.vue?vue&type=style&index=0&id=07d3b83a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d3b83a",
  null
  
)

export default component.exports